import { setToken, getToken, removeToken } from "@/utils/auth";
import { Notification } from "element-ui";
import { logout } from "@/api/index";

const state = {
  token: getToken(),
  user: {},
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
};

const actions = {
  setUser({ commit }, user) {
    commit("SET_USER", user);
  },
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
    setToken(token);
  },

  async logout({ commit, state }) {
    try {
      // 如果登录过有用户信息，才需要执行退出接口
      if (state.user.id) {
        const { code } = await logout();

        if (code !== 0) throw new Error("退出接口异常");

        Notification.success({
          title: "退出成功",
        });
      }

      commit("SET_USER", {});
      commit("SET_TOKEN", "");

      removeToken();
    } catch (error) {
      console.log(error);
    }
  },
};

const getters = {
  username: (state) => state.user?.name,
  unread_msg: (state) => state.user?.unread_msg,
  // 10 个人认证； 20 企业认证
  authType: (state) => state.user?.type,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
